/** True when axios/fetch aborted the request (React Strict Mode cleanup, filter churn, unmount). */
export function isRequestAbortError(error) {
  if (error == null) return false;
  if (error.code === "ERR_CANCELED") return true;
  if (error.name === "CanceledError" || error.name === "AbortError") return true;
  return false;
}
